// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.navbar.app-header {\n  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);\n  background-color: white;\n}\n.navbar.app-header .navbar-brand .logo {\n    max-height: 2.5em;\n    margin-bottom: 0;\n}\n.navbar.app-header .header-avatar {\n    margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
